<div class="container-hamburger-menu" [class.hamburger-menu-open]="opened" [class.hamburger-colours-inverted]="invertColours">
  <span class="hamburger-menu-bar hamburger-bar-top"></span>
  <span class="hamburger-menu-bar hamburger-bar-mid"></span>
  <span class="hamburger-menu-bar hamburger-bar-bot"></span>
</div>
